/// <amd-module name="VSS/Redux/Modules/VSSPageData/VSSPageDataSelectors" />
import { IVSSPageDataAwareState } from "./VSSPageDataContracts";
import { IPageData } from "VSS/Platform/Page";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";

export function getVssPageData(state: IVSSPageDataAwareState): IPageData | undefined {
    if (state.vssPageData) {
        return state.vssPageData;
    }
}

export function getCurrentUser(state: IVSSPageDataAwareState): IdentityRef | undefined {
    const vssPageData = getVssPageData(state);

    if (vssPageData) {
        return vssPageData.user;
    }
}
